import React from 'react';
import Image from 'next/image';
import { ExternalLinksProps } from '@/components/chat/types';

const ExternalLinks: React.FC<ExternalLinksProps> = ({ links, className = '' }) => (
  <div className={`tw-flex-col tw-gap-3 tw-hidden lg:tw-flex ${className}`}>
    <div className="tw-text-gray-700 tw-text-lg tw-font-semibold tw-font-['Lexend'] tw-leading-7">All My Links:</div>
    <div className="tw-flex tw-flex-wrap tw-gap-3">
      {links.map((link, index) => (
        <a
          key={index}
          className="tw-p-2 tw-cursor-pointer tw-bg-gray-100 tw-shrink-0 tw-rounded-[99px] tw-justify-start tw-items-center tw-gap-2.5 tw-flex"
          href={link.link}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Image
            priority
            quality={100}
            width={20}
            height={20}
            src={link.logo}
            alt={`Social link ${index + 1}`}
            title={`Social link ${index + 1}`}
          />
        </a>
      ))}
    </div>
  </div>
);

export default ExternalLinks;
